import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimoni" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1" style={{ marginBottom: '16px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
            Testimoni Klien
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Kepuasan dan kebahagiaan pasangan adalah kebanggaan terbesar kami
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '32px'
        }}>
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="hover-lift"
              style={{
                background: 'var(--bg-primary)',
                padding: '40px 32px',
                borderRadius: '0px',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/* Rating Stars */}
              <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} fill="var(--text-primary)" color="var(--text-primary)" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="body-regular" style={{
                color: 'var(--text-secondary)',
                lineHeight: '1.7',
                marginBottom: '24px',
                flex: 1,
                fontStyle: 'italic'
              }}>
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', borderTop: '1px solid var(--border-light)', paddingTop: '24px' }}>
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
                <div>
                  <h4 className="heading-3" style={{ marginBottom: '4px', fontSize: '16px' }}>
                    {testimonial.name}
                  </h4>
                  <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '2px' }}>
                    {testimonial.wedding}
                  </p>
                  <p className="body-small" style={{ color: 'var(--text-light)' }}>
                    {testimonial.date}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: '60px' }}>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
            Ingin menjadi bagian dari kisah sukses kami?
          </p>
          <a
            href="https://wa.me/6285951311360?text=Hallo%20Annisa%20Wedding%20%2C%20Saya%20mau%20konsultasi%20perihal%20Wedding"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Mulai Konsultasi
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
